import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { MemberService } from '@root/router/index/member.service';
import { TranslateService } from '@root/shared/service/translate.service';
import { ACLService } from '@delon/acl';
import { HttpClient } from '@angular/common/http';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'host-create-house',
  templateUrl: './create-house.component.html',
  styleUrls: ['./create-house.component.scss'],
})
export class CreateHouseComponent implements OnInit, AfterViewInit, OnDestroy {
  // @Input() displaySuccessAlert = true;
  nameForm: UntypedFormGroup = this.fb.group({
    listOfName: this.fb.array(['']),
  });

  repeatedNames = new Set();
  private destroy$ = new Subject();

  constructor(
    private fb: UntypedFormBuilder,
    private el: ElementRef,
    private subject: NzModalRef,
    private messageService: NzMessageService,
    private member: MemberService,
    private router: Router,
    private modalService: NzModalService,
    private t: TranslateService,
    private acl: ACLService,
    private http: HttpClient
  ) {}

  get listOfName() {
    return this.nameForm.get('listOfName') as UntypedFormArray;
  }

  get isSubAccount() {
    return this.acl.can({ role: ['slave'] });
  }

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.el.nativeElement.querySelector('.input-title').focus();
    }, 300);
  }

  checkRepeatedNames(name, index) {
    const values: string[] = this.listOfName.value.filter((v, i) => i !== index && !!v);
    if (values.indexOf(name) !== -1) {
      this.repeatedNames.add(index);
    } else {
      this.repeatedNames.delete(index);
    }
  }

  onNameChange(name, index) {
    this.checkRepeatedNames(name, index);
    console.log('repeated names: ', Array.from(this.repeatedNames));

    if (index === this.listOfName.length - 1) {
      this.listOfName.push(new UntypedFormControl(''));
    }
    console.log('name chage: ', index);
  }

  onNameDelete(index) {
    this.listOfName.removeAt(index);
    this.repeatedNames.delete(index);
  }

  onCancel() {
    this.subject.destroy();
  }

  onSave() {
    const titles = this.listOfName.value.filter((name) => !!name);

    if (this.member.isEditionExceedQuantityLimit(titles.length)) {
      this.exceedQuantityLimitWarning(titles);
      return;
    }

    // const cannotCreate = this.exceedQuantityLimitWarning(params);
    // if (cannotCreate) {
    //   return;
    // }
    this.http.post('/api/house/create', { titles: titles }).subscribe((res: any) => {
      if (res.error_code === 0) {
        // const successText = this.t.syncGet("success.house.create_house");
        // this.displaySuccessAlert && this.messageService.success(successText);
        this.subject.destroy('Ok');
      }
    });
  }

  exceedQuantityLimitWarning(titles) {
    // const isSubAccount = this.systemService.subAccountInfo.isSubAccount;

    // 对免费版需单独处理，如果超出了免费版最大限制数量，弹窗提醒
    // if (this.member.isFreeEditionExceedMaxQuantityLimit(titles.length)) {
    //   this.member.freeEditionCreateHouseLimitWarning();
    //   return;
    // }

    const remainingAvailableQuantity = this.member.remainingAvailableQuantity;
    if (!this.isSubAccount) {
      // 根据购买的房间上限，您最多还可创建${canCreateHouses}个房间，目前已超过上限。请删减房间或升级。
      const title = this.t.t('house.exceed_house_upper_limit', { canCreateHouses: remainingAvailableQuantity });
      this.modalService.warning({
        nzTitle: title,
        nzMaskClosable: false,
        nzOkText: this.t.t('free_edition_create_house_limit_btn_加购'),
        nzCancelText: this.t.t('house.delete_house'),
        nzOnOk: () => {
          this.modalService.closeAll();
          this.router.navigate(['/app/pay/upgrade']);
        },
      });
    } else {
      // 根据购买的房间上限，您最多还可创建${canCreateHouses}个房间，目前已超过上限。请删减房间或通知主账号升级。
      const title = this.t.t('house.sub_account_exceed_house_upper_limit', {
        canCreateHouses: remainingAvailableQuantity,
      });
      this.modalService.warning({
        nzTitle: title,
        nzMaskClosable: false,
        nzOkText: this.t.t('word.got_it'),
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
